export const RECRUITMENT_STATUS_MAPPING = {
  jrct: {
    "Enrolling by invitation": "Recruiting",
    "Terminated (Halted Prematurely)": "Complete",
    "Withdrawn (No Participants Enrolled)": "Suspended"
  }
}

export const PRIMARY_PURPOSE_MAPPING = {
  jrct: {
    "Device Feasibility": "Other",
  }
}

export const COUNTRY_MAPPING = {
  eupas: {
    "Korea, South": "Korea, Republic of"
  },
  eudra: {
    "Korea, South": "Korea, Republic of"
  }
}

export const STUDY_PHASE_MAPPING = {
  eupas: {
    "Early Phase 1 (or Phase 0)": "Phase 1",
    "Phase 1/Phase 2": "Phase 2",
    "Phase 2/Phase 3": "Phase 3"
  }
}

export const OBSERVATIONAL_STUDY_MODEL_MAPPING = {
  eupas: {
    "Family-Based": "Other",
    "Case-Crossover": "Other"
  },
  global: {

  },
  ctg: {
    "Cluster design": "Other",
    "Cross-sectional": "Other",
    "Systematic review and meta-analysis": "Other"
  }
}